import { AppBar, AppBarProps } from '@material-ui/core';
import React from 'react';

export type TabBarProps = AppBarProps & {
}

export function TabBar (props: TabBarProps) {
    return (
        <AppBar position="static" {...props} />
    )
}